import React, { Fragment } from 'react';
import Panel from '../../../../../components/outline/Panel';
import InputForm from '../../../../../components/form/InputForm';
import { REX_ASPHOHE_NUMBER } from '../../../../../lib/rex';
import { formRequiredRules } from '../../../../../lib/formRules';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import {
  AFTER_SERVICE_CAUTION_MAX_LENGTH,
  AFTER_SERVICE_INFO_MAX_LENGTH,
  AFTER_SERVICE_KAKAO_MAX_LENGTH,
  AFTER_SERVICE_MANUFACTURER_MAX_LENGTH,
  AFTER_SERVICE_ORIGIN_MAX_LENGTH,
  AFTER_SERVICE_QUALITY_ASSURANCE_MAX_LENGTH,
} from '../../../../../constants/service/app/productRegisterConstants';
import BaseForm from '../../../../../components/form/BaseForm';
import './BrandDetailProductRegisterAfterService.scss';

const BrandDetailProductRegisterAfterService = ({ data, form, isEditable }) => {
  const { asPhone, kakaoAccount, asInform, caution, qualityAssurance, manufacturer, origin } = data;

  return (
    <Panel className="brand-detail-product-register-after-service">
      <div className="panel-header">
        <div className="title">A/S</div>
      </div>

      <div className="panel-body">
        <BaseForm
          label="A/S정보"
          content={
            <Fragment>
              {/*A/S 전화번호*/}
              <InputForm
                label="A/S 전화번호"
                className="after-service-info"
                form={form}
                name="asPhone"
                isEditable={isEditable}
                initialValue={asPhone}
                vertical={true}
                rules={[
                  formRequiredRules(true, '필수 값입니다.'),
                  {
                    pattern: REX_ASPHOHE_NUMBER,
                    message: '입력한 A/S 전화번호가 올바르지 않습니다. 다시 입력해 주세요.',
                  },
                ]}
              />
              {/*카카오톡 (플러스친구)*/}
              <InputForm
                label="카카오톡 (플러스친구)"
                className="after-service-info"
                form={form}
                maxLength={AFTER_SERVICE_KAKAO_MAX_LENGTH}
                name="kakaoAccount"
                isEditable={isEditable}
                initialValue={kakaoAccount}
                vertical={true}
              />
              {/*A/S 안내*/}
              <TextAreaForm
                label="A/S 안내"
                className="after-service-info"
                form={form}
                rules={[formRequiredRules(true, '필수 값입니다.')]}
                maxLength={AFTER_SERVICE_INFO_MAX_LENGTH}
                withCount
                name="asInform"
                isEditable={isEditable}
                initialValue={asInform}
                vertical={true}
              />
            </Fragment>
          }
        />

        {/*착용시 주의 사항*/}
        <TextAreaForm
          label="착용시 주의 사항"
          form={form}
          maxLength={AFTER_SERVICE_CAUTION_MAX_LENGTH}
          withCount
          name="caution"
          isEditable={isEditable}
          initialValue={caution}
        />

        {/*품질보증 기준*/}
        <TextAreaForm
          label="품질보증 기준"
          form={form}
          maxLength={AFTER_SERVICE_QUALITY_ASSURANCE_MAX_LENGTH}
          withCount
          name="qualityAssurance"
          isEditable={isEditable}
          initialValue={qualityAssurance}
        />
        {/*제조자*/}
        <InputForm
          label="제조자"
          form={form}
          rules={[formRequiredRules(true, '필수 값입니다.')]}
          maxLength={AFTER_SERVICE_MANUFACTURER_MAX_LENGTH}
          withCount
          name="manufacturer"
          isEditable={isEditable}
          initialValue={manufacturer}
        />
        {/*제조국*/}
        <InputForm
          label="제조국"
          form={form}
          rules={[formRequiredRules(true, '필수 값입니다.')]}
          maxLength={AFTER_SERVICE_ORIGIN_MAX_LENGTH}
          withCount
          name="origin"
          isEditable={isEditable}
          initialValue={origin}
        />
      </div>
    </Panel>
  );
};

export default BrandDetailProductRegisterAfterService;
